import React from 'react';
import { connect } from 'react-redux';

import { deleteData } from '../../../../../../_actions/document-builder.actions';

function RemoveProperty({ item, dispatch }) {
  return <>
    <button
      onClick={() => {
        dispatch(deleteData());
      }}
      type="button" className="btn btn-outline-danger btn-block mt-4">Remove</button>
  </>
}

export default connect()(RemoveProperty);